import React from "react";
import i18n from "../../../../constants/i18n";
import {
  USER_EDIT_PROFILE_HEADERS,
  USER_EDIT_PROFILE_HISTORY_HEADERS
} from "../../../../constants/table-custom-headers/User";
import getUserEditProfileStore from "../../../../stores/user-store/edit-profile-store";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Table from "../../../../core/et3-table";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";

const UserEditProfileData = withLiteObserverAndTheme(() => {
  const { editProfileDataArray, profileHistoryDataArray } =
    getUserEditProfileStore().getUserEditDataArrays();

  return (
    <React.Fragment>
      <Et3Table
        columns={USER_EDIT_PROFILE_HEADERS}
        rows={editProfileDataArray}
        title={i18n.get("USER_EDIT_PROFILE")}
        shouldBeFlagged={false}
        titleKey={"EDIT_PROFILE"}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Table
        columns={USER_EDIT_PROFILE_HISTORY_HEADERS}
        rows={profileHistoryDataArray}
        title={i18n.get("USER_EDIT_PROFILE_ARCHIVE")}
        shouldBeFlagged={false}
        titleKey={"EDIT_PROFILE_HISTORY"}
      />
    </React.Fragment>
  );
});
export default UserEditProfileData;
